import type { IPriceImpactCalculator } from "../interfaces"

/**
 * Centralized Price Impact Calculator
 *
 * Calculates price impact consistently across all aggregators.
 * Never trust price impact from APIs - always calculate using this service.
 */
export class PriceImpactCalculator implements IPriceImpactCalculator {
  /**
   * Calculate price impact in basis points
   *
   * Formula: ((expectedOutputValue - actualOutputValue) / expectedOutputValue) * 10000
   *
   * Where:
   * - expectedOutputValue = inputAmountUsd (what you'd get at spot price)
   * - actualOutputValue = outputAmountUsd (what you actually get)
   *
   * Positive result = negative impact (you get less than expected)
   * Negative result = positive impact (you get more than expected)
   *
   * Returns null if calculation cannot be performed (missing prices, etc.)
   */
  calculate(inputAmountUsd: number, outputAmountUsd: number): number | null {
    if (inputAmountUsd <= 0 || outputAmountUsd <= 0) {
      return null
    }

    const impact = ((inputAmountUsd - outputAmountUsd) / inputAmountUsd) * 10000
    return Math.round(impact)
  }
}
